<div class="fixed-section">
    <section class="titleBarBg fixed-top">
        <div class="container-fluid">
            <div class="row mar-7px">
                <div class="w-3">
                    <img src="assets/images/manage_sales_plan_icon.svg" class="pageIcon" alt="">
                </div>
                <div class="w-97">
                    <div class="pageHeadingBar">
                        <div class="row">
                            <div class="col-md-6 align-self-center">
                                <h6 class="pageHeadingText mb-0 text-uppercase">MANAGE SALES PLAN</h6>
                            </div>
                            <div class="col-md-3 align-self-center">
                            </div>
                            <div class="col-md-3 align-self-center text-end">
                                <ul class="list-inline mb-0">
                                    <li class="list-inline-item">
                                        <div class="me-1 position-relative actionButton align-self-center dropdown-toggle" data-bs-toggle="dropdown"
                                            aria-expanded="false" (click)="deleteSelectedSalesPlans()" *ngIf="selectedSalesPlanIds.length > 0">
                                            <img src="assets/images/closered_circle 1.png" class="saveImg me-2" alt="" title="Delete">
                                            <span class="statusValue pe-2">DELETE</span>
                                        </div>
                                    </li>
                                    <li class="list-inline-item">
                                        <img src="assets/images/extract_icon.png" class="me-1 w-25px pointerCursor" alt=""
                                            title="Extract Sales Plan Data" (click)="ExtractSalesplanData()">
                                    </li>
                                    <li class="list-inline-item">
                                        <img src="assets/images/export.png" class="me-1 w-25px pointerCursor" alt=""
                                            title="Export" (click)="ExportSalesplanData()">
                                    </li>
                                    <li class="list-inline-item">
                                        <div class="nav-item dropdown">
                                            <a class="nav-link dropdown-toggle urserName" href="#" role="button"
                                                data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src="assets/images/filter.png" class="w-20px me-2" alt=""
                                                    title="Filter">
                                            </a>
                                            <ul class="dropdown-menu customMargindrp w-300">
                                                <div class="row mb-12px">
                                                    <div class="col-md-5">
                                                        <label>CATEGORY</label>
                                                    </div>
                                                    <div class="col-md-7 ps-0">
                                                        <p-multiSelect [options]="categoryList"
                                                            [(ngModel)]="selectedCategories" name="category"
                                                            [showHeader]="true" [filter]="true"
                                                            placeholder="Select Category"
                                                            (click)="stopPropagation($event)">
                                                            <ng-template pTemplate="header">
                                                                <div class="custom-multiselect-header">
                                                                    <span style="padding-right: 5px;">SELECT ALL</span>
                                                                </div>
                                                            </ng-template>
                                                        </p-multiSelect>
                                                    </div>
                                                </div>

                                                <!-- <div class="row mb-12px">
                                                    <div class="col-md-5">
                                                        <label>AGENCY</label>
                                                    </div>
                                                    <div class="col-md-7 ps-0">
                                                        <p-multiSelect [options]="agencies" [(ngModel)]="selectedAgencies" name="agency" [showHeader]="true"
                                                            [filter]="true" placeholder="Select Agency" (click)="stopPropagation($event)"
                                                            ></p-multiSelect>
                                                    </div>
                                                </div> -->

                                                <div class="row mb-12px">
                                                    <div class="col-md-5">
                                                        <label>STATUS</label>
                                                    </div>
                                                    <div class="col-md-7 ps-0">
                                                        <p-multiSelect [options]="statuses" [(ngModel)]="selectedStatus"
                                                            name="status" [showHeader]="true" [filter]="true"
                                                            placeholder="Select Status"
                                                            (click)="stopPropagation($event)"></p-multiSelect>
                                                    </div>
                                                </div>




                                                <div class="row ">
                                                    <div class="offset-md-5 col-md-7 ps-0">

                                                        <button class="btn progressBtn w-100" role="button"
                                                            (click)="getProjectData()">
                                                            APPLY FILTER
                                                        </button>
                                                    </div>
                                                </div>


                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</div>

<div class="middleContent">
    <section class="mt-131">
        <div class="container-fluid px-2">
            <div class="row">
                <div class="col-md-12">
                    <div class="card border-0 stepsBars-2 mb-5">
                        <div class="card-body">
                            <div class="main mx-0 pb-1">
                                <table class="table datatable border-x-0 mb-0">
                                    <tbody>
                                        <tr class="subheaderrr">
                                            <th width="18%" colspan="4">
                                                PROJECT TITLE
                                            </th>
                                            <th width="10%">
                                                CATEGORY
                                            </th>
                                            <th width="10%">
                                                REQUESTED BY
                                            </th>
                                            <th width="9%" (click)="sortSalesPlans('initiatedDate')"
                                                style="cursor:pointer;">
                                                INITIATED DATE
                                                <img *ngIf="sortColumn === 'initiatedDate'"
                                                    [src]="sortDirection === 'asc' ? 'assets/images/up-arrow.png' : 'assets/images/down-arrow.png'"
                                                    class="ms-1 w-10" />
                                            </th>
                                            <th width="8%" (click)="sortSalesPlans('startDate')"
                                                style="cursor:pointer;">
                                                START DATE
                                                <img *ngIf="sortColumn === 'startDate'"
                                                    [src]="sortDirection === 'asc' ? 'assets/images/up-arrow.png' : 'assets/images/down-arrow.png'"
                                                    class="ms-1 w-10" />
                                            </th>
                                            <th width="8%" (click)="sortSalesPlans('endDate')" style="cursor:pointer;">
                                                END DATE
                                                <img *ngIf="sortColumn === 'endDate'"
                                                    [src]="sortDirection === 'asc' ? 'assets/images/up-arrow.png' : 'assets/images/down-arrow.png'"
                                                    class="ms-1 w-10" />
                                            </th>
                                            <th width="6%">
                                                PWR #
                                            </th>
                                            <th width="6%">
                                                STORES
                                            </th>                                            
                                            <th class="border-end-0" width="10%">
                                                STATUS
                                            </th>
                                        </tr>
                                        <tr *ngFor="let sp of salesplanList; let i = index;">
                                            <td width="2%" class="vertical-align-middle text-center titleTdBg">
                                                <img src="assets/images/pencilIocn.svg" class="me-1 w-21 pointerCursor"
                                                    alt="" title="Edit"
                                                    (click)="navigateToEditSalesplan(sp.refId,sp.categoryIds)">
                                            </td>
                                            <td>
                                                <input type="checkbox" [checked]="selectedSalesPlanIds.includes(sp.headerId)"
                                                    (change)="onSalesPlanCheckboxChange(sp.headerId, $event)" />
                                            </td>
                                            <td class="text-center vertical-align-middle">
                                                <div *ngIf="sp.clonedProjects.length > 0">
                                                    <div class="position-relative d-inline-block">
                                                        <div>
                                                            <a class="nav-link dropdown-toggle urserName" href="#"
                                                                role="button" data-bs-toggle="dropdown"
                                                                aria-expanded="false">
                                                                <img src="assets/images/clone.png" class="w-17" alt="">
                                                            </a>
                                                            <ul class="dropdown-menu customMargindrp w-400">
                                                                <div class="tableFixHead">
                                                                    <table class="table datatable border-x-0 mb-0">
                                                                        <thead>
                                                                            <tr class="subheaderrr">
                                                                                <th width="10%" class="text-start">
                                                                                    CLONED PROJECTS
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr *ngFor="let clonedProject of sp.clonedProjects">
                                                                                <td>
                                                                                    <a href="javascript:void(0)"
                                                                                        (click)="navigateToEditSalesplan(clonedProject.projectId, clonedProject.categoryIds)">
                                                                                        {{ clonedProject.projectTitle }}
                                                                                    </a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="text-start vertical-align-middle titleTdBg">
                                                {{sp.projectTitle}}
                                            </td>

                                            <td class="text-center vertical-align-middle">
                                                {{sp.category}}
                                            </td>
                                            <td class="text-start vertical-align-middle">
                                                <strong>{{sp.requestedBy}}</strong>
                                            </td>
                                            <td class="text-center vertical-align-middle">
                                                {{sp.initiatedDate}}
                                            </td>
                                            <td class="text-center vertical-align-middle">
                                                {{sp.startDate}}
                                            </td>
                                            <td class="text-center vertical-align-middle">
                                                {{sp.endDate}}
                                            </td>
                                            <td class="text-center vertical-align-middle" width="5%">
                                                {{sp.pwR_Id}}
                                            </td>
                                            <td class="text-center vertical-align-middle">
                                                <div class="d-flex justify-content-between">
                                                    <div class="align-self-center">
                                                        {{sp.numberOfStores}}
                                                    </div>
                                                    <div *ngIf="sp.numberOfStores > 0">
                                                        <img src="assets/images/download_icon.svg" alt=""
                                                            class="pointerCursor"
                                                            (click)="downloadStoresExcel($event,sp.refId, sp.projectTitle)">
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="text-start vertical-align-middle status_td">
                                                <div class="nav-item dropdown d-flex justify-content-between">
                                                    <div>
                                                        <span class="draftTextColor">{{sp.status}}</span>
                                                    </div>
                                                    <div>
                                                        <a class="nav-link dropdown-toggle urserName" href="#"
                                                            role="button" data-bs-toggle="dropdown"
                                                            aria-expanded="false">
                                                            <img src="assets/images/down_arrow.png" class="w-17" alt="">
                                                        </a>
                                                        <ul class="dropdown-menu customMargindrp w-400">
                                                            <div class="tableFixHead">
                                                                <table class="table datatable border-x-0 mb-0">
                                                                    <thead>
                                                                        <tr class="subheaderrr">
                                                                            <th width="2%"></th>
                                                                            <th width="10%" class="text-start">
                                                                                DATE
                                                                            </th>
                                                                            <th width="15%" class="text-start">
                                                                                STATUS
                                                                            </th>
                                                                            <th width="20%" class="text-start">
                                                                                UPDATED BY
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr *ngFor="let spStatus of sp.projectStatuses">
                                                                            <td>
                                                                                <img src="assets/images/check-mark.png"
                                                                                    class="tableTickmark" alt=""
                                                                                    *ngIf="spStatus.updatedDate != null">
                                                                            </td>
                                                                            <td class="text-start ">
                                                                                <span
                                                                                    class="textNavyblue">{{spStatus.updatedDate}}</span>
                                                                            </td>
                                                                            <td class="text-start draftTextColor">
                                                                                {{spStatus.projectStatusText}}
                                                                            </td>
                                                                            <td>
                                                                                {{spStatus.updatedBy}}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="card" *ngIf="salesplanList!.length === 0 ">
                                    <div class="card-body py-2 px-3">
                                        <div class="emtyCard p-0">
                                            <p class="mb-0">No Records Found
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<p-confirmDialog position="top" [baseZIndex]="200000" appendTo="body" role="alertdialog"></p-confirmDialog>